// ---------- l'entonnoir de l'initiation ----------
// Ce que le tableau de bord de l'atelier compte de la première feuille d'un nouveau joueur
// (2026-10-31) : l'œil ouvert, commencé, fini ; le choix fait au bout, devant le renard ; le chien
// entier fini. Un compteur anonyme par jour et par étape côté serveur (routes/intro.ts) — rien ici
// ne désigne le joueur.
//
// CHAQUE ÉTAPE UNE FOIS PAR APPAREIL. L'entonnoir compte des joueurs, pas des passages : relancer
// l'application au milieu de l'œil le rouvre, « Revoir l'initiation » le rejoue, et ni l'un ni
// l'autre ne doit compter deux ouvertures. L'étape est notée envoyée quand le serveur l'a réglée ;
// hors ligne, elle repart à la prochaine occasion où elle se produit.

import { noteIntroStep } from './api';

export type IntroStep = 'opened' | 'started' | 'pieceDone' | 'finish' | 'library' | 'bigDone';

const KEY = 'cg.introSent';
/** Les envois partis et pas encore revenus : « commencé » se signale à chaque sauvegarde de la
 *  pièce, et deux sauvegardes rapprochées ne doivent pas faire deux envois. */
const inFlight = new Set<IntroStep>();

function sent(): Set<string> {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown;
    return new Set(Array.isArray(raw) ? raw.filter((x) => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

export function noteIntro(step: IntroStep): void {
  // Jamais depuis un serveur de développement : il parle à l'API de PRODUCTION, et un POST sans
  // corps est une requête « simple » que le navigateur envoie sans vérification préalable — elle
  // compterait au tableau de bord même si la réponse est ensuite refusée à localhost, et, la
  // réponse refusée, l'étape repartirait à chaque essai.
  if (import.meta.env.DEV) return;
  if (inFlight.has(step) || sent().has(step)) return;
  inFlight.add(step);
  void noteIntroStep(step).then((done) => {
    inFlight.delete(step);
    if (!done) return;
    try {
      localStorage.setItem(KEY, JSON.stringify([...sent(), step]));
    } catch {
      /* quota plein : l'étape repartira, au pire comptée deux fois */
    }
  });
}
